import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Redirect} from "react-router-dom";
import App from './App.js';
import Anagrafiche from "./components/registryComponent/Anagrafiche.js";
import Attivita from "./components/activity/Attivita.js";
import AttivitaDet1 from "./components/activity/AttivitaDet1.js";
import AttivitaDet from "./components/activity/AttivitaDet.js";
import BucheDet from "./components/geoRef/BucheDet.js";
import Dashboard from "./components/dashboard/Dashboard.js";
import TracciaCampo from "./components/geoRef/TracciaCampo.js";
import Manutenzione from "./components/maintenance/Manutenzione.js";
import reportWebVitals from './reportWebVitals.js';
import LogIn from "./components/LogIn.js";
import Notification from "./components/notifications/Notifiche.js";
import AddAtt from "./components/activity/AddAtt.js"
import {WebSocketLink} from "apollo-link-ws";
import {getCookie,deleteCookie} from "./utilis/utils"
import { useHistory } from 'react-router-dom';
import { getLoginUrl } from './config/env.js';

import {
    ApolloClient,
    InMemoryCache,
    ApolloProvider,
} from '@apollo/client';

// ============================================================================
// DEBUG LOGGING - Check browser console for connection details
// ============================================================================
console.log('='.repeat(60));
console.log('[DEBUG] 🚀 App Starting...');
console.log('[DEBUG] Environment:', process.env.REACT_APP_ENV);
console.log('[DEBUG] WebSocket URL (REACT_APP_BACKEND_WS):', process.env.REACT_APP_BACKEND_WS);
console.log('[DEBUG] Backend URL:', process.env.REACT_APP_BACKEND_URL);
console.log('[DEBUG] Node ENV:', process.env.NODE_ENV);
console.log('[DEBUG] All REACT_APP vars:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP')));
console.log('='.repeat(60));

ReactDOM.render(

  <React.StrictMode>
  	<Root/>
  </React.StrictMode>,
  document.getElementById('root')
);

function Root(){
    console.log('[DEBUG] Root() component mounting...');

    const history = useHistory();

    // Debug: Check token at mount time
    const initialToken = getCookie('accessToken');
    console.log('[DEBUG] Initial accessToken exists:', !!initialToken);
    console.log('[DEBUG] Initial accessToken (first 30 chars):', initialToken ? initialToken.substring(0, 30) + '...' : 'NONE');

    const [header,setHeader]=React.useState({
          connectionParams: () => {
            const token = getCookie('accessToken');
            console.log('[DEBUG] connectionParams() called');
            console.log('[DEBUG] Token exists:', !!token);
            return { headers: { Authorization: `Bearer ${token}` } };
          }
        });

    // Debug: Log WebSocket URL
    const wsUrl = process.env.REACT_APP_BACKEND_WS;
    console.log('[DEBUG] Creating WebSocketLink with URL:', wsUrl);
    console.log('[DEBUG] URL protocol:', wsUrl ? wsUrl.split('://')[0] : 'undefined');

    const [wsLink]=React.useState(() => {
        console.log('[DEBUG] WebSocketLink initialization starting...');

        const link = new WebSocketLink({
            uri: wsUrl,
            options: {
                reconnect: true,
                lazy: true,
                connectionParams: () => {
                    const token = getCookie('accessToken');
                    console.log('[DEBUG] WS connectionParams called, token:', !!token);
                    return { headers: { Authorization: `Bearer ${token}` } };
                },
                connectionCallback: (error) => {
                    if (error) {
                        console.error('[DEBUG] ❌ WebSocket connectionCallback ERROR:', error);
                    } else {
                        console.log('[DEBUG] ✅ WebSocket connectionCallback: Connected!');
                    }
                }
            }
        });

        // Add subscription client event listeners
        if (link.subscriptionClient) {
            console.log('[DEBUG] subscriptionClient available, adding event listeners');

            link.subscriptionClient.on('connecting', () => {
                console.log('[DEBUG] 🔄 WebSocket: connecting...');
            });
            link.subscriptionClient.on('connected', () => {
                console.log('[DEBUG] ✅ WebSocket: connected!');
            });
            link.subscriptionClient.on('reconnecting', () => {
                console.log('[DEBUG] 🔄 WebSocket: reconnecting...');
            });
            link.subscriptionClient.on('reconnected', () => {
                console.log('[DEBUG] ✅ WebSocket: reconnected!');
            });
            link.subscriptionClient.on('disconnected', () => {
                console.log('[DEBUG] ❌ WebSocket: disconnected');
            });
            link.subscriptionClient.on('error', (err) => {
                console.error('[DEBUG] ❌ WebSocket error event:', err);
            });
        } else {
            console.log('[DEBUG] ⚠️ subscriptionClient NOT available');
        }

        console.log('[DEBUG] WebSocketLink created successfully');
        return link;
    });

    const clearStorageAndCookies = () => {
        deleteCookie("accessToken")
        deleteCookie("refreshToken")
        localStorage.clear();
        sessionStorage.clear();
        if (window.location.pathname !== "/"){
             window.location.href = window.location.origin + "/";
        }
    }
    function setCookie(cookie){
        let cookieString = `${cookie.name}=${cookie.value}`;
        if (cookie.path) {
            cookieString = `${cookieString}; path=${cookie.path}`
        }
        if (cookie.maxAge) {
            cookieString = `${cookieString}; max-age=${cookie.maxAge}`
        }
        document.cookie = cookieString;
    }

    const getNewToken = async (refreshToken) => {
      const url = getLoginUrl('/api/login/refresh/');
      const data = {
        refresh:refreshToken
      };

      fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(result => {
            let accessToken = result?.access;
            setCookie({name:'accessToken', value: accessToken, maxAge:process.env.REACT_APP_EXPIRATION_SECONDS});
            let refreshToken=result?.refresh;
            if(refreshToken){
                 setCookie({name:'refreshToken', value: refreshToken, maxAge:process.env.REACT_APP_EXPIRATION_SECONDS});
            }
            setHeader({
              connectionParams: () => {
                return { headers: { Authorization: `Bearer ${accessToken}` } };
              }
            });
            if(!accessToken){
                clearStorageAndCookies();
            }
        })
        .catch(error => {
          clearStorageAndCookies();
          console.error('Si è verificato un errore:', error);
        });

    };

   /* function handleWebSocketError(errorEvent) {
      console.error('WebSocket connection error:', errorEvent);
      const refreshToken=getCookie("refreshToken");
      getNewToken(refreshToken);
    }*/


    //wsLink.subscriptionClient.on('error', handleWebSocketError);

    console.log('[DEBUG] Creating ApolloClient...');
    const client = new ApolloClient({
      link: wsLink,
      cache: new InMemoryCache(),
      onError: ({ networkError, graphQLErrors }) => {
        console.log('[DEBUG] ApolloClient onError triggered');
        if (networkError) {
            console.error('[DEBUG] Network Error:', networkError);
        }
        if (graphQLErrors) {
            console.error('[DEBUG] GraphQL Errors:', graphQLErrors);
            const refreshToken=getCookie("refreshToken");
              graphQLErrors.forEach((error) => {
                console.error('[DEBUG] GraphQL Error:', error.message);
                const errorMessage = error.message;
                if (errorMessage === 'Signature has expired' || errorMessage === 'You do not have permission to perform this action') {
                     // getNewToken(refreshToken);
                }
              });
        }
      },
    });
    console.log('[DEBUG] ApolloClient created successfully');


    return(
            <Router>
                <Route exact path="/">
                    <LogIn/>
                </Route>
                <ApolloProvider client={client}>
                    <Route path="/home">
                        <App/>
                    </Route>
                    <Route path="/anagrafiche">
                        <Anagrafiche />
                    </Route>
                    <Route path="/attivita">
                        <AttivitaDet1 />
                    </Route>
                    <Route path="/attivitaDettaglio">
                        <Attivita />
                    </Route>
                    <Route path="/dashboard">
                        <Dashboard />
                    </Route>
                    <Route path="/dettaglio" render = { props => <AttivitaDet {...props} /> } >
                    </Route>
                    <Route path="/bucheDettaglio">
                        <BucheDet />
                    </Route>
                    <Route path="/manutenzioneMacchinari">
                        <Manutenzione />
                    </Route>
                    <Route path="/tracciaAdL">
                        <TracciaCampo />
                    </Route>
                    <Route path="/attivita/aggiungiAttivita">
                        <AddAtt />
                    </Route>
                    <Route path="/modificaTraccia/:id" render = { props => <TracciaCampo {...props} /> } >
                    </Route>
                    <Route path="/notifiche" render = { props => <Notification {...props} /> } >
                    </Route>
                </ApolloProvider>
            </Router>

    )
}

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
